export type LifeCycleState = {
  error: Error;
};

export const initialLifeCycleState: LifeCycleState = {
  error: null,
};
